import React from "react";
import ReactGA from 'react-ga';
import ReactGA4 from "react-ga4";

export default class Step7 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSelected = this.handleSelected.bind(this);
    }

    handleSelected(e) {              
        this.props.manualHandleChange("employmentStatus", e.currentTarget.dataset.id);
        this.props.next();
    }

    componentDidMount() {
        ReactGA4.event({
            category: 'Step 7, Employment Status',
            action: 'Step 7, Employment Status',
            label: 'Step 7, Employment Status'
        });       
        
    }

    render () {
        return (
            <div className="step-item col-md-10">
                <div id="section-employment" className="section-question section-hide">
                    <div className="row question">
                        <div className="col-md-1"></div>    
                        <div className="col-md-10 text-center">
                            <p>What is your employment status?</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-10">
                            <ul className="credit-score">
                            {/* “Employed“,”Self-Employed”,”Retired” and “Other“ */}
                                <li className={`employed ${this.props.values.employmentStatus === 'Employed'?'active':''}`} data-id="Employed" onClick={this.handleSelected}>Employed</li>
                                <li className={`self-employed ${this.props.values.employmentStatus === 'Self-Employed'?'active':''}`} data-id="Self-Employed" onClick={this.handleSelected}>Self-Employed</li>
                                <li className={`retired ${this.props.values.employmentStatus === 'Retired'?'active':''}`} data-id="Retired" onClick={this.handleSelected}>Retired</li>
                                <li className={`other ${this.props.values.employmentStatus === 'Other'?'active':''}`} data-id="Other" onClick={this.handleSelected}>Other</li>
                                
                            </ul>
                            {/* <div className="buttons employment">
                                <div className="yes" data-id="Yes" onClick={this.handleSelected}>
                                    <span className="icon"></span>
                                    <span className="text">Yes</span>
                                </div>

                                <div className="no" data-id="No" onClick={this.handleSelected}>
                                    <span className="icon"></span>
                                    <span className="text">No</span>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4 text-center mt-5 mb-5">                            
                        <button type="button" id="btnsubmit-property-value" className="btn-block btn btn-lg btn-text-white btn-350 backBtn"
                                onClick={this.props.back}> Back </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
